import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FamiliaService } from 'src/app/services/familia.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ParametroEmpresaService } from 'src/app/services/parametro-empresa.service';
import { ProductoService } from 'src/app/services/producto.service';
import { RubroService } from 'src/app/services/rubro.service';
import { UnidadNegocioService } from 'src/app/services/unidad-negocio.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { v4 as uuidv4 } from 'uuid';

export interface IProductMultipleSelection {
  data: any[];
  origen: String;
}

@Component({
  selector: 'app-modal-seleccionar-producto',
  templateUrl: './modal-seleccionar-producto.component.html',
  styleUrls: ['./modal-seleccionar-producto.component.scss'],
  providers: [SecurityService],
})
export class ModalSeleccionarProductoComponent implements OnInit {
  // Output
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();
  @Output() onRemoteQuery: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSelectAll: EventEmitter<IProductMultipleSelection> = new EventEmitter<IProductMultipleSelection>();
  @Output() onUncheckProducto: EventEmitter<any> = new EventEmitter<any>();

  // Input
  @Input() origen: String = null;
  @Input() showFiltroActivoInactivo: Boolean = true;
  @Input() showSelectAll: Boolean = false;
  @Input() paginateLocally: Boolean = false;

  mode: 'SEARCH' | 'VIEW_SELECTED' = 'SEARCH';

  // Vars
  idAfecto = uuidv4();
  idExcento = uuidv4();

  // Modales
  @ViewChild('seleccionarProducto', { static: true })
  seleccionarProductoModal: ModalDirective;

  // Form
  formData: FormGroup;

  readonly TIPO_AFECTO: Number = 1;
  readonly TIPO_EXCENTO: Number = 2;

  // Vars
  showUnidadDeNegocioIfAllowed: Boolean = false;
  showInforAdicionar: Boolean = false;

  // Data
  private rutEmpresa: Number;
  private sucursalEmpresa: Number;
  checkAll: boolean = false;
  data: any = [];
  dataAll: any = null;
  dataAllGlobal: any = null;
  paginationContext: PaginationContext = new PaginationContext();
  busquedaIniciada: boolean = false;
  loading: boolean = false;
  dataSeleccionadaAll: Array<any> = [];
  optionsRubro: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsUnidadesDeNegocio: unidad_negocio[] = [];
  public permiteUnidadNegocio: boolean = false;
  allChecked: boolean = false;
  checkedRecords: number = 0;
  codeProductSearched: string = '';
  lastSKU: string = '';
  /** true si la búsqueda por SKU empezó desde el formulario de detalle (p. ej. nota de venta) */
  private skuBusquedaDesdeFormularioDetalle = false;
  // Utils
  private log: any;
  showAll: number = 0;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private rubroService: RubroService,
    private familiaService: FamiliaService,
    private productoService: ProductoService,
    private unidadNegocioService: UnidadNegocioService,
    private parametroEmpresaService: ParametroEmpresaService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService
  ) {
    this.log = this.clog.log('MODAL-SELECCION-PRODUCTO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.parametroUnidadNegocio();
    this.loadRubros();
    this.loadUnidadNegocio();

    this.createForm();
    this.formChangesSubscriptions();
  }

  formChangesSubscriptions() {
    this.formData
      .get('descripcion')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((descripcion) => {
        if (descripcion !== null && descripcion !== undefined) {
          this.buscar(true);
        }
      });
    this.formData
      .get('sku')
      .valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((sku) => {
        if (!sku) {
          this.buscar(true);
        }
      });
  }

  parametroUnidadNegocio() {
    this.parametroEmpresaService.permiteUnidadNegocio(Number(this.rutEmpresa), ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.permiteUnidadNegocio = respuesta.valor_bool;
    });
  }

  /********* LOADS *********/
  private loadRubros() {
    this.rubroService.obtenerRubros(this.rutEmpresa, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsRubro = registros.map((p) => ({ value: p.codigo, label: p.descripcion }));
    });
  }

  loadUnidadNegocio() {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        tipo: 1,
      },
    };
    this.optionsUnidadesDeNegocio = [];
    this.unidadNegocioService.obtenerUnidadNegocio(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsUnidadesDeNegocio = registros.map((unidad_negocio) => ({
        value: unidad_negocio.codigo,
        label: unidad_negocio.nombre,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formData.get('unidad_negocio_codigo'), this.optionsUnidadesDeNegocio);
    });
  }

  private createForm() {
    this.formData = this.fb.group({
      descripcion: [''],
      sku: [''],
      rubro: [[]],
      familia: [[]],
      activo: [true],
      afectoOrExento: [this.TIPO_AFECTO],
      unidad_negocio_codigo: [null, []],
    });
  }

  setActivoFilter(esActivo: boolean) {
    this.formData.get('activo').setValue(esActivo);
  }

  /********* SHOW/HIDE *********/
  show(
    {
      cleanData,
      showInforAdicionar,
    }: {
      cleanData?: Boolean;
      showInforAdicionar?: Boolean;
    } = { cleanData: true }
  ) {
    this.mode = 'SEARCH';
    this.loading = false;
    if (cleanData) {
      this.cleanAll();
    }
    this.showInforAdicionar = showInforAdicionar;
    this.seleccionarProductoModal.show();
  }

  showSelected(dataAll: any[]) {
    this.loading = false;
    this.paginateLocally = true;
    this.mode = 'VIEW_SELECTED';
    this.dataAll = dataAll;
    this.dataAll.forEach((element, index) => {
      element.additionalInfo = {};
      element.additionalInfo.checked = true;
      element.additionalInfo.index = index;
    });
    this.recalculatePageSelectedContext(1);
    this.showPage(1);
    this.seleccionarProductoModal.show();
  }

  showWithConfig(
    {
      cleanData,
      showUnidadDeNegocioIfAllowed,
      defaultUnidadNegocio,
      showInforAdicionar,
    }: {
      cleanData?: Boolean;
      showUnidadDeNegocioIfAllowed?: Boolean;
      showInforAdicionar?: Boolean;
      defaultUnidadNegocio?: number | null;
    } = { cleanData: true, showUnidadDeNegocioIfAllowed: false, defaultUnidadNegocio: null }
  ) {
    this.mode = 'SEARCH';
    this.loading = false;
    if (cleanData) {
      this.cleanAll();
    }

    let setDefaultValues = false;
    if (defaultUnidadNegocio !== null && defaultUnidadNegocio !== undefined) setDefaultValues = true;

    if (setDefaultValues) this.setDefaultValues({ unidad_negocio_codigo: defaultUnidadNegocio });

    this.showUnidadDeNegocioIfAllowed = showUnidadDeNegocioIfAllowed;
    this.showInforAdicionar = showInforAdicionar;
    this.seleccionarProductoModal.show();
  }

  MostrarConConfiracionVendedorCliente(
    {
      cleanData,
      showUnidadDeNegocioIfAllowed,
      defaultUnidadNegocio,
      showInforAdicionar,
      origen,
    }: {
      cleanData?: Boolean;
      showUnidadDeNegocioIfAllowed?: Boolean;
      showInforAdicionar?: Boolean;
      defaultUnidadNegocio?: number | null;
      origen?: string;
    } = { cleanData: true, showUnidadDeNegocioIfAllowed: false, defaultUnidadNegocio: null, origen: null }
  ) {
    this.mode = 'SEARCH';
    this.loading = false;
    this.origen = origen;
    if (cleanData) {
      this.cleanAll();
    }

    let setDefaultValues = false;
    if (defaultUnidadNegocio !== null && defaultUnidadNegocio !== undefined) setDefaultValues = true;

    if (setDefaultValues) this.setDefaultValues({ unidad_negocio_codigo: defaultUnidadNegocio });

    this.showUnidadDeNegocioIfAllowed = showUnidadDeNegocioIfAllowed;
    this.showInforAdicionar = showInforAdicionar;
    this.seleccionarProductoModal.show();
  }

  hide() {
    this.seleccionarProductoModal.hide();
  }
  /********* SHOW/HIDE *********/

  recalculatePageSelectedContext(pageNumber: number) {
    this.paginationContext.RecordsCount = this.dataAll.length; //totalRegistros
    this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
    this.paginationContext.CurrentPage = pageNumber;
    if (pageNumber > this.paginationContext.PagesCount) this.paginationContext.CurrentPage = this.paginationContext.PagesCount;
  }

  private cleanAll() {
    this.loading = false;
    this.cleanFormData();
    this.cleanResultData();
    this.cleanDataAll();
  }
  private cleanDataAll() {
    this.data = [];
    this.dataAll = null;
    this.checkedRecords = 0;
    this.dataSeleccionadaAll = [];
    this.productosSeleccionados = [];
  }
  private cleanFormData() {
    this.enableUnidadNegocio();
    this.formData.reset();
    this.formData.markAsPristine();
    this.formData.markAsUntouched();

    this.initializeFormData();
  }

  enableUnidadNegocio() {
    this.formData.get('unidad_negocio_codigo').enable();
  }

  disableUnidadNegocio() {
    this.formData.get('unidad_negocio_codigo').disable();
  }

  private initializeFormData() {
    this.log('initializeFormData');
    this.formData.get('descripcion').setValue('');
    this.formData.get('sku').setValue('');
    this.formData.get('rubro').setValue([]);
    this.formData.get('familia').setValue([]);
    this.formData.get('activo').setValue(true);
    this.formData.get('afectoOrExento').setValue(this.TIPO_AFECTO);

    if (this.optionsUnidadesDeNegocio && this.optionsUnidadesDeNegocio.length > 0)
      this.formValidatorsService.selectFirstOrDefault(this.formData.get('unidad_negocio_codigo'), this.optionsUnidadesDeNegocio);
  }

  setDefaultValues({ unidad_negocio_codigo }: { unidad_negocio_codigo: number }) {
    this.formData.get('unidad_negocio_codigo').setValue(unidad_negocio_codigo);

    if (unidad_negocio_codigo !== null && unidad_negocio_codigo !== undefined) {
      this.disableUnidadNegocio();
    }
  }

  private cleanResultData() {
    this.busquedaIniciada = false;
    this.data = [];
    //this.dataAll = null
    this.loading = false;
    this.allChecked = false;
    //this.checkedRecords = 0
    //this.dataSeleccionadaAll = []
    //this.productosSeleccionados = []
  }

  private cleanResultDataRecords() {
    //this.dataAll = []
    // this.checkedRecords = 0;
    // this.dataSeleccionadaAll = [];
    // this.productosSeleccionados = [];
    // this.paginateLocally = false;
  }
  /********* FORM *********/

  /********* OPERATIONS *********/
  onRubroSelect(ev) {
    const listaRubros = this.formData.get('rubro').value;
    this.optionsFamilia = [];
    for (let i = 0; i < listaRubros.length; i++) {
      this.loadFamilias(listaRubros[i]);
    }
  }

  private loadFamilias(codigoRubro: Number) {
    this.familiaService.obtenerFamiliaxRubro(this.rutEmpresa, codigoRubro, ({ respuesta }) => {
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      let options = registros.map((p) => ({ value: p.codigo, label: p.nombre }));
      this.optionsFamilia = this.optionsFamilia.concat(options);
    });
  }

  private validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  private createInputParams() {
    return {
      empresa_rut: this.rutEmpresa,
      sucursal_codigo: this.sucursalEmpresa,
      sku: this.formData.get('sku').value ? this.formData.get('sku').value.trim() : '',
      descripcion: this.formData.get('descripcion').value ? this.formData.get('descripcion').value.trim() : '',
      tipobusqueda_estado: Number(this.formData.get('activo').value) === 1 ? 1 : 2, // 1: Activo, 2:Inactivo; // 0: Todos
      tipobusquedad_afecto_exento: Number(this.formData.get('afectoOrExento').value), //  === this.TIPO_AFECTO ? 1 : 2,
      familia: this.formData.get('familia').value,
      rubro: this.formData.get('rubro').value,
      paginaActual: this.paginateLocally ? 1 : this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginateLocally ? -1 : this.paginationContext.RecordsByPage,
    };
  }

  buscar(fromStartPage: Boolean = true) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1;

    // limpiar datos antes de desplegar
    this.cleanResultData();
    const inputParams = this.createInputParams();
    this.handleSearchByOrigin(inputParams);
  }

  private handleSearchByOrigin(inputParams) {
    this.log('this.onRemoteQuery.observers', this.onRemoteQuery.observers);
    this.loading = true;
    if (!this.onRemoteQuery.observers || this.onRemoteQuery.observers.length === 0) {
      // Query Local
      this.log('query local', JSON.stringify(inputParams));
      if (this.origen == 'RB_VC') {
        this.productoService.obtenerSegunFiltroProductosVC(inputParams, (result) => this.renderQueryResults(result));
      } else {
        this.productoService.obtenerSegunFiltroProductos(inputParams, (result) => this.renderQueryResults(result));
      }
    } else {
      // Query Remota
      // const { unidad_negocio_codigo } = this.formData.value
      const unidad_negocio_codigo = this.formValidatorsService.obtenerValorFormHeader(this.formData, 'unidad_negocio_codigo');
      inputParams = { ...inputParams, unidad_negocio_codigo };
      this.log('query remota');
      this.onRemoteQuery.emit({ inputParams, callback: (results) => this.renderQueryResults(results) });
    }
  }

  private renderQueryResults(result: QueryResult) {
    const { registros, paginaActual, totalPaginas, totalRegistros } = result;
    this.loading = false;
    this.log('renderQueryResults', registros, paginaActual, totalPaginas, totalRegistros);
    // this.dataAll = registros
    // this.dataAll.forEach(element => {
    //   //element.rutFormato = this.rutService.AgregarDV(element.rut)
    //   element.additionalInfo = {}
    //   element.additionalInfo.checked  = false
    //   this.removeElementTypename(element)
    // });
    if (this.paginateLocally) {
      this.dataAll = registros;

      this.paginationContext.RecordsCount = this.dataAll.length; //totalRegistros
      this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
      this.paginationContext.CurrentPage = 1;
      this.dataAll.forEach((element, index) => {
        // delete element.__typename
        this.removeElementTypename(element);
        element.additionalInfo = {};
        element.additionalInfo.checked = false;
        element.additionalInfo.index = index;
      });
      this.showPage(this.paginationContext.CurrentPage);
      if (this.productosSeleccionados.length > 0) {
        this.productosSeleccionados.forEach((producto) => {
          this.dataAll.map((x) => {
            if (x.codigo == producto.codigo) {
              x.additionalInfo.checked = producto.additionalInfo.checked;
            }
          });

          this.dataAll = this.dataAll;
        });
      }
    } else {
      this.paginationContext.RecordsCount = totalRegistros;
      this.paginationContext.CurrentPage = paginaActual;
      this.paginationContext.PagesCount = totalPaginas;
      this.data = registros;
      this.data.forEach((element) => {
        // delete element.__typename
        this.removeElementTypename(element);
        element.additionalInfo = {};
        element.additionalInfo.checked = false;
      });
    }
    this.busquedaIniciada = true;
    this.setCheckFromSeleccionados();
  }

  private setCheckFromSeleccionados() {
    this.dataSeleccionadaAll = this.productosSeleccionados;
    this.dataSeleccionadaAll.forEach((clienteSeleccionado) => {
      this.data
        .filter((pro) => this.match(pro, clienteSeleccionado))
        .map((cliente) => {
          cliente.checked = true;
        });
    });
    this.log(this.dataSeleccionadaAll);
  }
  private match(skuA, skuB) {
    // if (this.searchByCodeProduct) {
    //   return (clienteA.rut === clienteB.rut)
    // }

    return skuA.codigo === skuB.codigo;
  }

  private removeElementTypename(register: any) {
    delete register.__typename;
    return register;
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage;
    this.buscar(false);
  }

  onPageChangeLocal(context: PaginationContext) {
    this.showPage(context.RequestedPage);
  }

  showPage(pageNumber: number) {
    this.paginationContext.CurrentPage = pageNumber;
    if (pageNumber > this.paginationContext.PagesCount) this.paginationContext.CurrentPage = this.paginationContext.PagesCount;
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage;
    this.data = _.slice(this.dataAll, start, start + this.paginationContext.RecordsByPage);
  }

  // Se consume desde la vista
  selectData(producto: any, fromInlineSkuSearch: boolean = false) {
    this.skuBusquedaDesdeFormularioDetalle = false;
    // const _producto = { ...producto }
    const _producto = _.cloneDeep(producto);
    delete _producto.rutFormato;
    delete _producto.additionalInfo;
    // delete _producto.__typename
    this.lastSKU = _producto.sku;
    this.onSelect.emit({
      data: _producto,
      origen: this.origen,
      fromInlineSkuSearch,
    });
    this.log('selecciono', _producto);
    this.hide();

    //limpieza de variables
    this.dataAll = [];
    this.paginationContext.CurrentPage = 1;
    this.paginationContext.PagesCount = 10;
    this.cleanResultData();
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: KeyboardEvent) {
    this.CerrarModal();
  }

  CerrarModal() {
    //limpieza de variables
    this.dataAll = [];
    this.paginationContext.CurrentPage = 1;
    this.paginationContext.PagesCount = 10;
    this.cleanResultData();
    this.hide();
  }

  selectChecked() {
    let data: any = [];
    if (this.showAll == 1) {
      data = this.dataAll.filter((p) => p.additionalInfo.checked);
    } else {
      data = this.productosSeleccionados; //this.dataAll.filter((p) => p.additionalInfo.checked == true);
    }
    data.forEach((element) => {
      delete element.additionalInfo;
    });
    this.onSelectAll.emit({
      data,
      origen: this.origen,
    });
    this.hide();
  }

  private notFound() {
    const desdeFormulario = this.skuBusquedaDesdeFormularioDetalle;
    const skuBuscado = this.lastSKU;
    this.skuBusquedaDesdeFormularioDetalle = false;
    if (desdeFormulario) {
      this.onNotFound.emit({ fromInlineSkuNotFound: true, skuBuscado });
    } else {
      this.onNotFound.emit();
    }
  }

  // Método para ser consumido desde fuera del componente
  searchBySKU(sku: string, includeInactive: boolean = false, desdeFormularioDetalle: boolean = false) {
    const skuTrimmed = sku != null ? String(sku).trim() : '';
    if (!includeInactive && skuTrimmed === '') {
      return;
    }
    if (!includeInactive) {
      this.skuBusquedaDesdeFormularioDetalle = desdeFormularioDetalle;
    }
    // setTimeout(() => {
    if (this.lastSKU !== skuTrimmed || includeInactive) {
      this.lastSKU = skuTrimmed;
      // return
      const inputParams = {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        sku: skuTrimmed,
        descripcion: '',
        tipobusqueda_estado: includeInactive ? -1 : 1, // -1: Todos, 1: Activo, 0:Inactivo
        tipobusquedad_afecto_exento: 0,
        familia: [],
        rubro: [],
        paginaActual: 1,
        cantidadRegistrosPorPagina: 10,
      };
      if (!this.onRemoteQuery.observers || this.onRemoteQuery.observers.length === 0) {
        // Query Local
        this.log('searchBySKU query local', includeInactive ? 'incluyendo inactivos' : 'solo activos');
        this.productoService.obtenerSegunFiltroProductos(inputParams, (data) => {
          this.handleResultFromOutterSearch(data, includeInactive);
        });
      } else {
        // Query Remota
        this.log('searchBySKU query remota', includeInactive ? 'incluyendo inactivos' : 'solo activos');
        this.onRemoteQuery.emit({ inputParams, callback: (results) => this.handleResultFromOutterSearch(results, includeInactive, inputParams.sku) });
      }
    }
    // }, 500)
  }

  lastcodeProduct: string = '';

  searchByCodeProduct(codeProduct: string) {
    this.codeProductSearched = codeProduct;
    // Query Local
    if (this.lastcodeProduct !== codeProduct) {
      this.lastcodeProduct = codeProduct;

      const inputParams = {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        sku: this.lastcodeProduct,
        descripcion: '',
        tipobusqueda_estado: 1, // 1: Activo, 0:Inactivo
        tipobusquedad_afecto_exento: 0,
        familia: [],
        rubro: [],
        paginaActual: 1,
        cantidadRegistrosPorPagina: 10,
      };

      this.productoService.ObtenerSegunSku(inputParams, ({ mensajes, respuesta }) => {
        this.handleResultFromOutterSearch(respuesta, false);
      });
    }
  }

  private handleResultFromOutterSearch({ totalRegistros, registros }, includeInactive: boolean = false, skuSearched: string = '') {
    this.log('handleResultFromOutterSearch 2', totalRegistros, registros, 'includeInactive:', includeInactive, 'sku:', skuSearched);
    if (totalRegistros > 0) {
      // SI VIENE SKUSEARCHED SE BUSCA DE MANERA ESPECIFICA EN REGISTROS
      const producto = skuSearched.length > 0 ? registros.find(r => r.sku == skuSearched) : registros[0];
      
      if (!producto) {
        this.notFound();
        return;
      };

      this.removeElementTypename(producto);

      // Verificar si el producto está inactivo y manejar accordingly
      if (!producto.activo && !includeInactive) {
        // Producto encontrado pero está inactivo, buscar incluyendo inactivos
        this.log('Producto inactivo encontrado, buscando con includeInactive=true');
        this.searchBySKU(producto.sku, true);
        return;
      } else if (!producto.activo && includeInactive) {
        // Producto inactivo encontrado en segunda búsqueda, emitir evento especial
        this.onProductoInactivoEncontrado(producto);
        return;
      }

      this.selectData(producto, true);
    } else if (!includeInactive) {
      // No se encontró en búsqueda de activos, intentar con inactivos
      this.log('No encontrado en activos, buscando en inactivos');
      this.lastSKU = skuSearched.length === 0 ? this.lastSKU : skuSearched;
      this.searchBySKU(this.lastSKU, true);
    } else {
      // No se encontró ni en activos ni en inactivos
      this.notFound();
    }
  }

  private onProductoInactivoEncontrado(producto: any) {
    // Emitir evento especial para productos inactivos encontrados
    this.log('Producto inactivo encontrado:', producto);
    this.skuBusquedaDesdeFormularioDetalle = false;
    // Podemos usar el evento onNotFound pero con información del producto
    this.onNotFound.emit({ producto, esInactivo: true });
  }

  public clearLast() {
    this.lastSKU = '';
    this.lastcodeProduct = '';
    this.codeProductSearched = '';
    this.skuBusquedaDesdeFormularioDetalle = false;
  }

  toogleCheckProducto(producto, { checked }) {
    this.showAll = 0;
    this.toogleCheck(producto);
    this.handleChecked(producto.codigo, checked);
  }
  productosSeleccionados: Array<any> = [];
  private toogleCheck(producto) {
    producto.additionalInfo.checked = !producto.additionalInfo.checked;
    if (producto.additionalInfo.checked === true) {
      this.productosSeleccionados.push(producto);
    } else {
      this.productosSeleccionados = this.productosSeleccionados.filter((p) => p.additionalInfo.checked === true);
    }

    this.log(this.productosSeleccionados);
  }

  private handleChecked(codigo: number, check: boolean) {
    let checked: any;
    if (codigo) {
      this.dataAll.map((detalle) => {
        if (detalle.codigo === codigo) {
          detalle.additionalInfo.checked = check;
        }
      });

      this.data.map((detalle) => {
        if (detalle.codigo === codigo) {
          detalle.additionalInfo.checked = check;
        }
      });
    } else {
      checked = this.dataAll.filter((p) => p.additionalInfo.checked).length;
    }

    this.allChecked = this.dataAll.length === checked;
    if (this.showAll === 1) {
      this.checkedRecords = this.dataAll.length;
    } else {
      let dataSelect = this.productosSeleccionados; //this.dataAll.filter((p) => p.additionalInfo.checked);

      this.showAll == 0;
      this.checkedRecords = dataSelect.length;

      if (dataSelect.length < this.dataAll.length) {
        this.checkAll = false;
      } else {
        this.checkAll = true;
      }
    }
  }

  checkAllChange({ checked }) {
    this.showAll = 1; // Selected 1 es cuando es ALL checked
    this.dataAll.forEach((detalle: any) => {
      detalle.additionalInfo.checked = checked;
    });
    this.data.forEach((detalle: any) => {
      detalle.additionalInfo.checked = checked;
    });
    //if (!this.dataSeleccionadaAll) this.dataSeleccionadaAll = []
    this.productosSeleccionados = this.dataAll;
    // const _scopeSelected = this.dataAll//.filter((detalle: any) => detalle.checked)
    // _scopeSelected.forEach(producto => {
    //   this.addOrRemoveFromSelected(producto)
    // });
    const index = null;
    const check = null;
    this.handleChecked(index, check);
    if (checked === false) {
      this.checkedRecords = 0;
      this.cleanResultDataRecords();
    }
  }

  toogleCheckAll() { }

  public uncheckProductoSeleccionado(producto) {
    producto.additionalInfo.checked = false;
    const indexAll = this.dataAll.findIndex((p) => p.sku === producto.sku);
    if (indexAll > 0) this.dataAll[indexAll].additionalInfo.checked = false;
    this.dataAll = this.dataAll.filter((p) => p.additionalInfo.checked);
    this.recalculatePageSelectedContext(this.paginationContext.CurrentPage);
    this.showPage(this.paginationContext.CurrentPage);
    this.onUncheckProducto.emit(producto);
  }

  limpiar() {
    this.checkAll = false;
    this.data = [];
    this.dataAll = [];
    this.showAll = 0;
    this.checkedRecords = 0;
  }
  /********* OPERATIONS *********/

  // remote query for modal selección Producto
  public getProductsByUnidadNegocio({ inputParams, callback }) {
    // this.log('inputParams', JSON.stringify(inputParams))
    // {
    //   "empresa_rut": 76150970,
    //   "sku": "",
    //   "descripcion": "",
    //   "tipobusqueda_estado": 1,
    //   "tipobusquedad_afecto_exento": 1,
    //   "familia": [],
    //   "rubro": [],
    //   "paginaActual": 1,
    //   "cantidadRegistrosPorPagina": 10
    // }
    if (this.permiteUnidadNegocio) {
      const innerInputParams = {
        entidad: {
          empresa_rut: inputParams.empresa_rut,
          sucursal_codigo: inputParams.sucursal_codigo,
          sku: inputParams.sku,
          descripcion: inputParams.descripcion,
          tipobusqueda_estado: inputParams.tipobusqueda_estado,
          tipobusquedad_afecto_exento: inputParams.tipobusquedad_afecto_exento,
          listaFamilia: inputParams.familia,
          listaRubro: inputParams.rubro,
          unidad_negocio_codigo: inputParams.unidad_negocio_codigo,
        },
        paginaActual: inputParams.paginaActual,
        cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina,
      };

      this.log('inputParams (Unidad Negocio)', JSON.stringify(inputParams));

      this.productoService.obtenerSegunFiltroProductosUnidadNegocio(innerInputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    } else {
      this.log('inputParams', JSON.stringify(inputParams));
      this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes);
          return;
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0));
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
      });
    }
  }
}
